import {field} from "../../../../stem-core/state/StoreField.js";
import {apiClient} from "../../../connection/BlinkApiClient.js";
import {TaskStatus} from "../../misc/GenericEnums";
import {BaseStore, globalStore} from "../../../../stem-core/state/Store.js";
import {Merchant} from "../../MerchantStore";
import {MerchantAudience} from "../MerchantAudienceStore";
import {StemDate} from "../../../../stem-core/time/Date";
import type {StoreId} from "../../../../stem-core/state/State";

// MailChimpMergeTag in api/external_providers/mailchimp: how a MailChimp merge field maps onto a Blink user field
export interface MailChimpMergeTag {
    name: string;
    key: string;
    defaultValue: string | null;
    blinkField: string;
    blinkFieldParam: string | null;
}

@globalStore
export class MerchantMailChimpUserList extends BaseStore("MerchantMailChimpUserList", {dependencies: ["Merchant"]}) {
    @field("Merchant") merchant: Merchant;

    @field(String) mcListId: string;
    @field(String) clientKeyRegion: string;
    // @field(String) clientKey;  // not sent to front end

    @field(String) interestCategoryTitle: string;
    @field(String) interestCategoryId: string;
    @field(Array) mergeTags: MailChimpMergeTag[];

    @field(TaskStatus) lastSyncStatus: TaskStatus;
    @field(Number) lastSyncProgress: number;
    @field(Date) lastSyncStartedAt: StemDate;
    @field(Date) lastSyncUpdatedAt: StemDate;
    @field(Date) lastSyncFinishedAt: StemDate;
}

@globalStore
export class MerchantMailChimpInterest extends BaseStore("MerchantMailChimpInterest", {dependencies: ["Merchant", "MerchantMailChimpUserList", "MerchantAudience"]}) {
    @field("Merchant") merchant: Merchant;
    @field("MerchantMailChimpUserList") userList: MerchantMailChimpUserList;
    @field("MerchantAudience") audience: MerchantAudience;
    @field(String) interestId: string;
    @field(String) interestName: string;
}

export async function apiSyncMailChimpUserList(userListId: StoreId) {
    return apiClient.post("/external_providers/sync_mail_chimp_user_list/", {
        userListId,
    });
}
